import { render, staticRenderFns } from "./MaterialRequisitionPrint.vue?vue&type=template&id=3487031e&scoped=true&"
import script from "./MaterialRequisitionPrint.vue?vue&type=script&lang=js&"
export * from "./MaterialRequisitionPrint.vue?vue&type=script&lang=js&"
import style0 from "./MaterialRequisitionPrint.vue?vue&type=style&index=0&id=3487031e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3487031e",
  null
  
)

export default component.exports